@if (config) {
  @if (config.route) {
    <a [routerLink]="config.route" [queryParams]="config.queryParams" class="ec-status-card group" [class.ec-status-card--loading]="loading">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  } @else {
    <div class="ec-status-card" [class.ec-status-card--loading]="loading">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  }
}

<ng-template #content>
  <div class="flex flex-col gap-3 p-5 flex-grow">

    @if (loading) {
      <!-- Label visible while loading so the card is identifiable -->
      <span class="text-xs text-gray-400 dark:text-gray-500 leading-4 line-clamp-2 min-h-8 block opacity-60">
        {{ (config.label || '-') | translate }}
      </span>
      <!-- Skeleton placeholder for the value -->
      <div class="h-9 w-1/2 rounded-xl bg-black/10 dark:bg-white/10 mt-1"></div>

    } @else if (hasError) {
      <!-- Error state — mirrors skeleton heights (h-8 label, h-9 value row) -->
      <span class="text-xs text-gray-400 dark:text-gray-500 leading-4 line-clamp-2 min-h-8 block">
        {{ (config.label || '-') | translate }}
      </span>
      <div class="flex items-center gap-1.5 text-red-400 h-6 mt-1">
        <lucide-icon [name]="CircleAlert" size="13"></lucide-icon>
        <span class="text-xs font-medium">{{ 'common.error.fetch' | translate }}</span>
      </div>

    } @else {
      <div class="ec-status-card__content flex flex-col gap-3">
        <!-- Label row — fixed two-line height so all cards stay the same size -->
        <div class="flex items-start gap-1.5">
          <span class="text-xs text-gray-400 dark:text-gray-500 leading-4 line-clamp-2 min-h-8">
            {{ (config.label || '-') | translate }}
          </span>
          @if (config.tooltip) {
            <span
              class="shrink-0 text-amber-500"
              [tooltip]="config.tooltip | translate"
              tooltipPosition="top"
            >
              <lucide-icon [name]="CircleAlert" size="14"></lucide-icon>
            </span>
          }
          @if (isOverLimit) {
            <span class="shrink-0 text-xs font-semibold px-1.5 py-0.5 rounded-full
                         bg-amber-50 text-amber-600
                         dark:bg-amber-500/10 dark:text-amber-400
                         animate-[ec-fade-up_0.25s_ease-out_both]">
              {{ overLimitPercent }}
            </span>
          }
        </div>

        <!-- Value -->
        @if (config.statusCodes) {
          <div class="flex items-center gap-2 mt-1">
            <div class="w-4 h-4 rounded-full shadow-sm {{value}}"></div>
            <span class="text-xs text-gray-400 dark:text-gray-500">
              {{ value?.toString()?.includes('green') ? 'OK' : value?.toString()?.includes('red') ? 'Fejl' : 'Advarsel' }}
            </span>
          </div>
        } @else {
          <div class="text-2xl font-medium tabular-nums leading-none mt-1" [class]="numberClass">
            {{ value ?? '—' }}
          </div>
        }
      </div>
    }

  </div>

  <!-- Bottom accent stripe — hidden while loading -->
  @if (!loading) {
    <div class="h-0.5 w-full flex-shrink-0 transition-colors duration-300" [class]="accentClass"></div>
  }

  <!-- Over-limit warning icon -->
  @if (isOverLimit && !loading) {
    <div class="absolute top-3 right-3 animate-[ec-fade-up_0.25s_ease-out_both]">
      <lucide-icon [name]="TriangleAlert" size="14" class="text-amber-500 dark:text-amber-400"></lucide-icon>
    </div>
  }

  <!-- Arrow for links -->
  @if (config.route && !loading && !hasError) {
    <div class="absolute bottom-3 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-150">
      <lucide-icon [name]="ArrowUpRight" size="13" class="text-gray-300 dark:text-gray-600"></lucide-icon>
    </div>
  }
</ng-template>
